








































































































































import EventCardContainer from '@/components/layouts/EventCardContainer.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import { ActionNames as PatientNoteActionNames } from '@/store/modules/patient-note/keys'
import { toReadableTimeFromTimestamp } from '@/components/exercises/measure/filters'
import { getFriendlyEventName } from '@/view-model/patient-event-constants/MemberPatientEvents'
import moment from 'moment-timezone'
import { PATIENT_STATS_PAGE_TYPES } from '@/utils/constants'
import { FlatPatientWithEvents } from '@/store/modules/patient-with-events/getters'
import NoteActionMeMenu from '@/components/sub-components/NoteActionMenu.vue'
import { NOTE_PRESETS } from '@/constants/note-presets'
import { getNoteId } from '@/utils/notes'
import { PATIENT_NOUN } from '@/constants/app-variables'
import { RoomNumbersWithPatientPhotos } from '@/constants/patient-photos'

export default {
  components: {
    EventCardContainer,
    NoteActionMeMenu,
  },
  filters: {
    toReadableTimeFromTimestamp,
    getFriendlyEventName,
  },
  props: {
    patientWithEvents: {
      type: Object,
      required: true,
    },
    patientNotes: {
      type: Array,
      required: true,
    },
    borderColor: {
      type: String,
      default: '',
    },
    maxEventDisplayNum: {
      type: Number,
      default: 1,
    },
    maxNoteDisplayNum: {
      type: Number,
      default: 5,
    },
    showPatientPhoto: {
      type: Boolean,
      default: false,
    },
    isGeneratingExport: {
      type: Boolean,
      default: false,
    },
    routePageType: {
      type: String,
      required: true,
      validate: text =>
        Object.values(PATIENT_STATS_PAGE_TYPES)
          .map(v => v.key)
          .includes(text),
    },
  },
  data() {
    return {
      isOpeningNote: false,
      isOpeningEditor: false,
      noteText: '',
      isSending: false,
      editingNoteId: '',
      editingNote: '',
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, {
      patientNameById: PatientGetterNames.patientNameMapById,
      patients: PatientGetterNames.patients,
    }),
    ...mapState(ModuleNames.app, { userId: 'userId' }),
    eventsOnlyLatestDay(): FlatPatientWithEvents[] {
      const latestEventDay = moment(this.patientWithEvents.events[0].eventTimestamp).startOf('day')
      return this.patientWithEvents.events.filter(
        event =>
          moment(event.eventTimestamp)
            .startOf('day')
            .diff(latestEventDay, 'days') === 0
      )
    },
    patient() {
      return this.patients.find(p => p.id === this.patientWithEvents.id)
    },
    slicedPatientWithEvents(): FlatPatientWithEvents[] {
      return {
        ...this.patientWithEvents,
        events: this.eventsOnlyLatestDay.slice(0, this.maxEventDisplayNum),
      }
    },
    patientPhotoBackground() {
      //temporary solution until patient photos are available thru the API
      if (this.patient.roomNumber && RoomNumbersWithPatientPhotos.includes(this.patient.roomNumber)) {
        return {
          backgroundImage: `url(${require(`@/assets/patient-images/room_${this.patient.roomNumber}.png`)})`,
        }
      }
      return {
        backgroundImage: `url(${require('@/assets/patient-images/placeholder.png')})`,
      }
    },
  },
  methods: {
    ...mapActions(ModuleNames.patientNotes, [
      PatientNoteActionNames.getPatientNotes,
      PatientNoteActionNames.addPatientNote,
      PatientNoteActionNames.patchPatientNote,
      PatientNoteActionNames.deletePatientNote,
    ]),
    closeNotes(): void {
      this.isOpeningNote = false
      this.isOpeningEditor = false
      this.noteText = ''
    },
    openNotes(): void {
      this.isOpeningNote = true
      this.isOpeningEditor = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    async sendNote(content): Promise<void> {
      if (this.isSending) {
        return
      }

      this.isSending = true
      await this[PatientNoteActionNames.addPatientNote]({
        content,
        patientId: this.patientWithEvents.id,
      }).catch(error => {
        if (error && error.response && error.response.status == 403) {
          alert("Sorry, you're not authorized to add a note for this " + PATIENT_NOUN.toLowerCase() + '.')
        }
      })

      this.isSending = false
      this.noteText = ''
      this.isOpeningNote = true
    },
    async updateNote(note): Promise<void> {
      if (this.isSending) {
        return
      }

      const updateId = this.getNoteId(note)
      if (this.editingNote === note.content) {
        // console.log('cancel patch request')
      } else {
        this.isSending = true
        await this[PatientNoteActionNames.patchPatientNote]({
          id: updateId,
          content: this.editingNote,
        })
        this.isSending = false
      }

      this.finishEditing()
    },
    async deleteNote(note): Promise<void> {
      if (this.isSending) {
        return
      }

      const deleteNoteId = this.getNoteId(note)
      this.isSending = true
      await this[PatientNoteActionNames.deletePatientNote]({ id: deleteNoteId })
      this.isSending = false
      this.finishEditing()
    },
    getPresetIcon(content: string): string {
      const preset = NOTE_PRESETS.find(_preset => content.toLowerCase().includes(_preset.text.toLowerCase()))
      return preset ? preset.icon : 'mdi-note-text-outline'
    },
    editNote(note): void {
      this.editingNoteId = this.getNoteId(note)
      this.editingNote = note.content

      this.$nextTick(() => {
        this.$refs[this.getNoteId(note)][0].focus()
      })
    },
    finishEditing(): void {
      this.editingNoteId = null
    },
    getNoteId,
  },
}
